var $572079ed86210ca9$exports = {};
$572079ed86210ca9$exports = {
    "(optional)": `(optioneel)`,
    "(required)": `(vereist)`
};


export {$572079ed86210ca9$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
